import WelcomePage from '../pages/welcome-page.vue'
import GoodbyePage from '../pages/goodbye-page.vue'
import CompaniesApplyPage from '../pages/companies/apply.vue'
import InvestorsApplyPage from '../pages/investors/apply.vue'
import GroupsApplyPage from '../pages/groups/apply.vue'
import { requireAuthentication } from '@/modules/auth/routes/middleware'

export default [
  {
    component: GoodbyePage,
    name: 'public.goodbye',
    path: '/goodbye',
  },
  {
    component: WelcomePage,
    name: 'public.welcome',
    path: '/:slug',
  },
  {
    component: GroupsApplyPage,
    name: 'public.groups.apply',
    path: '/groups',
  },
  {
    component: CompaniesApplyPage,
    name: 'public.companies.apply',
    path: '/:slug/companies/apply',
    beforeEnter: requireAuthentication,
  },
  {
    component: InvestorsApplyPage,
    name: 'public.investors.apply',
    path: '/:slug/investors/apply',
    beforeEnter: requireAuthentication,
  },
  {
    component: InvestorsApplyPage,
    name: 'public.group-users.apply',
    path: '/:slug/groups/apply',
    beforeEnter: requireAuthentication,
  },
]
